// extracted by mini-css-extract-plugin
export var acitonButtons = "_gf-0";
export var additionalIcon = "_gf-f";
export var block = "_gf-1";
export var blockContent = "_gf-7";
export var blockDescription = "_gf-8";
export var blockIcon = "_gf-9";
export var blockTitle = "_gf-6";
export var border = "_gf-a";
export var center = "_gf-l";
export var edge = "_gf-b";
export var edgeLabel = "_gf-c";
export var edgePath = "_gf-d";
export var error = "_gf-e";
export var flowchart = "_gf-g";
export var flowchartContent = "_gf-h";
export var highlighted = "_gf-3";
export var hover = "_gf-4";
export var icon = "_gf-i";
export var left = "_gf-m";
export var navButton = "_gf-j";
export var navButtons = "_gf-k";
export var right = "_gf-n";
export var selected = "_gf-2";
export var small = "_gf-5";